import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { format } from 'date-fns'
import { groupBy } from 'lodash-es'
import { type TimeRange } from '@/infra/time-range'

import { ConsolidatedTimeSlot, ConsolidatedTimeSlotGroup } from './index'

interface ConsolidatedTimeSlotListContainerProps {
  timeRanges: TimeRange[]
}

/**
 * Container component that renders consolidated time slots grouped by date
 */
export const ConsolidatedTimeSlotListContainer = observer(
  function ConsolidatedTimeSlotListContainer({
    timeRanges,
  }: ConsolidatedTimeSlotListContainerProps) {
    const timeSlotsByDay = useMemo(() => {
      return groupBy(timeRanges, (slot) => slot.startTime.toDateString())
    }, [timeRanges])

    return (
      <>
        {Object.entries(timeSlotsByDay).map(([day, slots], dayIndex) => (
          <ConsolidatedTimeSlotGroup
            key={dayIndex}
            header={format(new Date(day), 'EEE, MMM d')}
          >
            {slots.map((slot, slotIndex) => (
              <ConsolidatedTimeSlot
                key={slotIndex}
                startTime={format(slot.startTime, 'h:mm a')}
                endTime={format(slot.endTime, 'h:mm a')}
              />
            ))}
          </ConsolidatedTimeSlotGroup>
        ))}
      </>
    )
  },
)
